import { useState, useEffect } from "react";
import { TelemIdxType } from "cstore/telem";
import { getTelemSet, subscribeTelemSet } from "utils/packet-workers";

export const useTelemSet = (): { fieldName: string, fieldType: TelemIdxType }[] => {
    const [ telemSet, setTelemSet ] = useState( getTelemSet );
    useEffect( () => subscribeTelemSet( () => setTelemSet( getTelemSet() ) ), [] );
    return telemSet;
};
